import fonts from './fonts'

const textStyles = {
  titleH1: `
    ${fonts.BbComputerCondBold}
    font-size: 3rem;
    line-height: 1;
    text-transform: uppercase;
  `,
  titleH3: `
    ${fonts.BbComputerCondBold}
    font-size: 1.8rem;
    line-height: 1;
    text-transform: uppercase;
  `,
  text: `
    ${fonts.BbComputerRegular}
    font-size: 1.4rem;
    line-height: 1.5;
  `,
  label: `
    ${fonts.BbComputerRegular}
    font-size: 1.4rem;
    line-height: 1;
    text-transform: uppercase;
  `,
  locale: `
    ${fonts.BbComputerRegular}
    font-size: 1.2rem;
    line-height: 1.5;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  `,
}

export default textStyles
